import React, { Component } from 'react'
import Loader from '../../../../shared/components/Loader.jsx'
import { Link } from 'react-router'
import { BackIcon } from '../slots/SlotsNav.jsx'
import { defineMessages, FormattedMessage } from 'react-intl'
import { jacktopConstants } from './jacktop_constants'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { getJacktopGamesToken } from '../../../../actions/jacktopGames/creators/jacktopGames'

const messages = defineMessages({
  games_back_to_games: {
    id: 'games.back_to_games',
    defaultMessage: 'Назад к списку игр',
  },
  black_jack: {
    id: 'games.jacktop.black_jack',
    defaultMessage: 'Блэкджек',
  },
  roulette: {
    id: 'games.jacktop.roulette',
    defaultMessage: 'Рулетка',
  },
  poker: {
    id: 'games.jacktop.poker',
    defaultMessage: 'Покер',
  },
  baccarat: {
    id: 'games.jacktop.baccarat',
    defaultMessage: 'Баккара',
  },
})

const allowedCountries = ['KG', 'UZ']

class JacktopGames extends Component {
  static contextTypes = {
    footer: React.PropTypes.object,
  }

  openAuthModal = () => this.props.dispatch({ type: 'BEGIN_SIGNIN' })

  handleGameClick = (gameId) => {
    const { gamblerId, languageId, getJacktopGamesToken } = this.props

    if (!gamblerId) {
      return this.openAuthModal()
    } else {
      getJacktopGamesToken(languageId, gameId)
    }
  }

  render() {
    const { countryCode, jacktopGames } = this.props

    if (!allowedCountries.includes(countryCode)) {
      this.props.push('/')
      return null
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '90vh' }}>
        {jacktopGames.fetching && <Loader />}
        <div style={{ flexGrow: 1 }}>
          <div className="slots--wrapper">
            <div className="slots__nav">
              <Link to="/games" className="slots--back" activeClassName="active">
                <BackIcon />
                <FormattedMessage {...messages.games_back_to_games} />
              </Link>
            </div>
            <div className="slots__list">
              {Object.entries(jacktopConstants.games).map(([gameName, gameData]) => (
                <div
                  className="slots__game"
                  key={gameName + gameData.id}
                  onClick={() => this.handleGameClick(gameData.id)}
                >
                  <div className="slots__game--img" style={{ width: '100%', objectFit: 'cover' }}>
                    <img src={gameData.img} alt={gameData.id} />
                  </div>
                  <div className="slots__game--name">
                    <FormattedMessage {...messages[gameName]} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{ flexShrink: 0 }}>{this.context.footer}</div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const user = state.auth.get('user')
  const accountResourceId = user ? user.get('resourceId') : 1
  const gamblerId = user ? user.get('gamblerId') : null

  return {
    user,
    gamblerId,
    accountResourceId,
    countryCode: state.application.get('countryCode'),
    languageId: state.application.get('languageId'),
    jacktopGames: state.application.get('jacktopGames'),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getJacktopGamesToken: (languageId, gameId) => dispatch(getJacktopGamesToken(languageId, gameId)),
    push: (url) => dispatch(push(url)),
    dispatch,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(JacktopGames)



// WEBPACK FOOTER //
// ./js/sport-betting/components/games/jacktop/JacktopGames.jsx